import React, { useState } from "react";
import { connect } from "react-redux";
import { Container, Content, Title, i18n, tokens } from "@simplybenefits/sb-ui-library";
import EnrichedAcademyModal from "../../components/EnrichedAcademyModal.js";
import PerksList from "./PerksList.js";

/**
 * 
 * @param {*} coverage
 * @param {*} user
 * @param {*} whitelabel 
 * @returns 
 */
const Perks = ({ coverage, user, whitelabel }) => {
    const [ showEnrichedAcademyModal, setShowEnrichedAcademyModal ] = useState(false);

    return (
        <Container>
            <Content>
                <Title title={i18n.t(tokens.labels.perks.simplyPerks)} />
                
                <PerksList
                    user={user}
                    coverage={coverage}
                    whitelabel={whitelabel}
                    onEnrichedAcademyClick={() => setShowEnrichedAcademyModal(true)}
                />

                {showEnrichedAcademyModal && (
                    <EnrichedAcademyModal 
                        open={showEnrichedAcademyModal}
                        toggleOpen={() => setShowEnrichedAcademyModal((prev) => !prev)}
                        user={user}
                    />
                )}
            </Content>
        </Container>
    );
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    coverage: state.coverage.data,
    user: state.user,
    whitelabel: state.whitelabel
});

export default connect(mapStateToProps)(Perks);